import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Feed from '../components/Feed';
import PinDetail from '../components/PinDetail';
import ConversationDetail from '../components/ConversationDetail';
import JoinFamily from '../components/JoinFamily';
import VidDetail from '../components/Posts/VidDetail';


const Pins = ({ user, setView }) => {

  useEffect(() => {
  setView("Home");
  }, [])

  return (
    <div className="px-2 md:px-5">
      
      <div className="h-full">
        <Routes>
          <Route path="/*" element={<Feed user={user && user} setView={setView}/>} />
          <Route path="/category/:categoryId" element={<Feed user={user && user} setView={setView}/>} />
          <Route path="/pin-detail/:pinId" element={<PinDetail user={user && user} />} />
          <Route path="/conversation-detail/:conId" element={<ConversationDetail user={user && user} />} />
          <Route path="/Join-family/:famId" element={<JoinFamily user={user && user} />} />
          <Route path="/vid-detail/:vidId" element={<VidDetail user={user && user} />} />
        </Routes>
      </div>
    </div>
  );
};

export default Pins;

